import React from "react";
import { NavLink } from "react-router-dom";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import QuizIcon from "@mui/icons-material/Quiz";

const MoreMenu = ({ 
  isOpen, 
  onClose, 
  EmployeeProfile, 
  handleNoMessage, 
  handleNoProfile,
  activeClassName,
  msg_notification,
  dispatch,
  message_notification 
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
        onClick={onClose}
      />
      
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl z-50 md:hidden animate-slide-up">
        <div className="flex justify-center pt-2 pb-3">
          <div className="w-12 h-1 bg-gray-300 rounded-full" />
        </div>
        
        <div className="px-6 pb-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">More Options</h3>
          
          <nav>
            <ul className="space-y-2">
              <li>
                {EmployeeProfile.message === null ? (
                  <div
                    className="flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors"
                    onClick={() => {
                      handleNoMessage();
                      onClose();
                    }}
                  >
                    <div className="flex-shrink-0">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.168 0.666016L4.83464 0.666016C2.53464 0.666016 0.667969 2.52435 0.667969 4.81602L0.667969 9.79935L0.667969 10.6327C0.667969 12.9243 2.53464 14.7827 4.83464 14.7827H6.08464C6.30964 14.7827 6.60964 14.9327 6.7513 15.116L8.0013 16.7743C8.5513 17.5077 9.4513 17.5077 10.0013 16.7743L11.2513 15.116C11.4096 14.9077 11.6596 14.7827 11.918 14.7827H13.168C15.468 14.7827 17.3346 12.9243 17.3346 10.6327V4.81602C17.3346 2.52435 15.468 0.666016 13.168 0.666016ZM9.83464 10.4577L4.83464 10.4577C4.49297 10.4577 4.20964 10.1743 4.20964 9.83268C4.20964 9.49102 4.49297 9.20768 4.83464 9.20768L9.83464 9.20768C10.1763 9.20768 10.4596 9.49102 10.4596 9.83268C10.4596 10.1743 10.1763 10.4577 9.83464 10.4577ZM13.168 6.29102L4.83464 6.29102C4.49297 6.29102 4.20964 6.00768 4.20964 5.66602C4.20964 5.32435 4.49297 5.04102 4.83464 5.04102L13.168 5.04102C13.5096 5.04102 13.793 5.32435 13.793 5.66602C13.793 6.00768 13.5096 6.29102 13.168 6.29102Z"
                          fill="#898989"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-base font-medium text-gray-800">Messages</p>
                      <p className="text-sm text-gray-500">View your conversations</p>
                    </div>
                  </div>
                ) : (
                  <NavLink
                    to={"/user/messages"}
                    className="flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors relative"
                    onClick={() => {
                      dispatch(message_notification(0));
                      onClose();
                    }}
                  >
                    <div className="flex-shrink-0">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.168 0.666016L4.83464 0.666016C2.53464 0.666016 0.667969 2.52435 0.667969 4.81602L0.667969 9.79935L0.667969 10.6327C0.667969 12.9243 2.53464 14.7827 4.83464 14.7827H6.08464C6.30964 14.7827 6.60964 14.9327 6.7513 15.116L8.0013 16.7743C8.5513 17.5077 9.4513 17.5077 10.0013 16.7743L11.2513 15.116C11.4096 14.9077 11.6596 14.7827 11.918 14.7827H13.168C15.468 14.7827 17.3346 12.9243 17.3346 10.6327V4.81602C17.3346 2.52435 15.468 0.666016 13.168 0.666016ZM9.83464 10.4577L4.83464 10.4577C4.49297 10.4577 4.20964 10.1743 4.20964 9.83268C4.20964 9.49102 4.49297 9.20768 4.83464 9.20768L9.83464 9.20768C10.1763 9.20768 10.4596 9.49102 10.4596 9.83268C10.4596 10.1743 10.1763 10.4577 9.83464 10.4577ZM13.168 6.29102L4.83464 6.29102C4.49297 6.29102 4.20964 6.00768 4.20964 5.66602C4.20964 5.32435 4.49297 5.04102 4.83464 5.04102L13.168 5.04102C13.5096 5.04102 13.793 5.32435 13.793 5.66602C13.793 6.00768 13.5096 6.29102 13.168 6.29102Z"
                          fill="#7066A3"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <p className="text-base font-medium text-gray-800">Messages</p>
                      <p className="text-sm text-gray-500">View your conversations</p>
                    </div>
                    {msg_notification > 0 && (
                      <div className="flex-shrink-0">
                        <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 rounded-full">
                          {msg_notification}
                        </span>
                      </div>
                    )}
                  </NavLink>
                )}
              </li>

              <li>
                <NavLink
                  to={"/user/interview"}
                  className="flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors"
                  onClick={onClose}
                >
                  <div className="flex-shrink-0">
                    <QuizIcon style={{ fontSize: 24, color: "#7066A3" }}/>
                  </div>
                  <div className="flex-1">
                    <p className="text-base font-medium text-gray-800">AI Interview</p>
                    <p className="text-sm text-gray-500">Practice with AI</p>
                  </div>
                </NavLink>
              </li>

              <li>
                {EmployeeProfile.message === null ? (
                  <div
                    className="flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors"
                    onClick={() => {
                      handleNoProfile();
                      onClose();
                    }}
                  >
                    <div className="flex-shrink-0">
                      <CastForEducationIcon style={{ fontSize: 24, color: "#898989" }} />
                    </div>
                    <div className="flex-1">
                      <p className="text-base font-medium text-gray-800">Career Coach</p>
                      <p className="text-sm text-gray-500">Get career guidance</p>
                    </div>
                  </div>
                ) : (
                  <NavLink
                    to="/career-coach"
                    className="flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors"
                    onClick={onClose}
                  >
                    <div className="flex-shrink-0">
                      <CastForEducationIcon style={{ fontSize: 24, color: "#7066A3" }} />
                    </div>
                    <div className="flex-1">
                      <p className="text-base font-medium text-gray-800">Career Coach</p>
                      <p className="text-sm text-gray-500">Get career guidance</p>
                    </div>
                  </NavLink>
                )}
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default MoreMenu;
